module.exports = __webpack_public_path__ + "img/reportAvatar1.d7f16ecd.png";